import { render, staticRenderFns } from "./FormErrorAlert.vue?vue&type=template&id=2bbded37&"
import script from "./FormErrorAlert.vue?vue&type=script&lang=js&"
export * from "./FormErrorAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports